import { NamirasoftFieldCookieHeader } from "./NamirasoftFieldCookieHeader";
import { NamirasoftFieldReqHeader } from "./NamirasoftFieldReqHeader";
import { NamirasoftFieldResHeader } from "./NamirasoftFieldResHeader";

export class NamirasoftFieldHeader
{
    static cookie: NamirasoftFieldCookieHeader = new NamirasoftFieldCookieHeader();
    static req: NamirasoftFieldReqHeader = new NamirasoftFieldReqHeader();
    static res: NamirasoftFieldResHeader = new NamirasoftFieldResHeader();

}